/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as Vision_test_plansRouteRouteImport } from './routes/vision_test_plans/route'
import { Route as QualityPacksRouteRouteImport } from './routes/quality-packs/route'
import { Route as ProjectsRouteRouteImport } from './routes/projects/route'
import { Route as ProductsRouteRouteImport } from './routes/products/route'
import { Route as OperationsRouteRouteImport } from './routes/operations/route'
import { Route as ImportsRouteRouteImport } from './routes/imports/route'
import { Route as FactoriesRouteRouteImport } from './routes/factories/route'
import { Route as Cause_categoriesRouteRouteImport } from './routes/cause_categories/route'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as Vision_test_plansIndexRouteImport } from './routes/vision_test_plans/index'
import { Route as QualityPacksIndexRouteImport } from './routes/quality-packs/index'
import { Route as ProjectsIndexRouteImport } from './routes/projects/index'
import { Route as ProductsIndexRouteImport } from './routes/products/index'
import { Route as ProductionPlannerIndexRouteImport } from './routes/production-planner/index'
import { Route as OperationsIndexRouteImport } from './routes/operations/index'
import { Route as InboxIndexRouteImport } from './routes/inbox/index'
import { Route as ImportsIndexRouteImport } from './routes/imports/index'
import { Route as FactoriesIndexRouteImport } from './routes/factories/index'
import { Route as DebugIndexRouteImport } from './routes/debug/index'
import { Route as Change_controlIndexRouteImport } from './routes/change_control/index'
import { Route as Cause_categoriesIndexRouteImport } from './routes/cause_categories/index'
import { Route as Bill_of_operationsIndexRouteImport } from './routes/bill_of_operations/index'
import { Route as AuditIndexRouteImport } from './routes/audit/index'
import { Route as Vision_test_plansTest_plan_idRouteImport } from './routes/vision_test_plans/$test_plan_id'
import { Route as QualityPacksWorkOrderIdRouteImport } from './routes/quality-packs/$workOrderId'
import { Route as ProjectsTimelineRouteImport } from './routes/projects/timeline'
import { Route as ProjectsProjectIdRouteImport } from './routes/projects/$projectId'
import { Route as ProductsNewRouteImport } from './routes/products/new'
import { Route as ProductsProductIdRouteImport } from './routes/products/$productId'
import { Route as ProductionPlannerTimelineRouteImport } from './routes/production-planner/timeline'
import { Route as OperationsNewRouteImport } from './routes/operations/new'
import { Route as OperationsOperation_idRouteImport } from './routes/operations/$operation_id'
import { Route as ImportsImportIdRouteImport } from './routes/imports/$importId'
import { Route as Change_controlRun_idRouteImport } from './routes/change_control/$run_id'
import { Route as ProductsContainersRouteRouteImport } from './routes/products/containers/route'
import { Route as AdminPartnersRouteRouteImport } from './routes/admin/partners/route'
import { Route as AdminFeatureFlagsRouteRouteImport } from './routes/admin/feature-flags/route'
import { Route as AdminContainersRouteRouteImport } from './routes/admin/containers/route'
import { Route as ProductsContainersIndexRouteImport } from './routes/products/containers/index'
import { Route as ColumnsStructuredConfigurationIndexRouteImport } from './routes/columns/structured-configuration/index'
import { Route as ColumnsCustomConfigurationIndexRouteImport } from './routes/columns/custom-configuration/index'
import { Route as Bill_of_operationsRulesIndexRouteImport } from './routes/bill_of_operations/rules/index'
import { Route as AdminPartnersIndexRouteImport } from './routes/admin/partners/index'
import { Route as AdminFeatureFlagsIndexRouteImport } from './routes/admin/feature-flags/index'
import { Route as AdminContainersIndexRouteImport } from './routes/admin/containers/index'
import { Route as ProjectsProjectIdTimelineRouteImport } from './routes/projects/$projectId_.timeline'
import { Route as ProjectsProjectIdReleaseRouteImport } from './routes/projects/$projectId_.release'
import { Route as ProjectsProjectIdRedraftRouteImport } from './routes/projects/$projectId_.redraft'
import { Route as ProjectsProjectIdGanttRouteImport } from './routes/projects/$projectId_.gantt'
import { Route as ProjectsProjectIdBill_of_operationsRouteImport } from './routes/projects/$projectId_.bill_of_operations'
import { Route as ProductsContainersContainerIdRouteImport } from './routes/products/containers/$containerId'
import { Route as OperationsOperation_idStationsRouteImport } from './routes/operations/$operation_id_.stations'
import { Route as OperationsOperation_idChecksRouteImport } from './routes/operations/$operation_id_.checks'
import { Route as OperationsOperation_idBill_of_operationsRouteImport } from './routes/operations/$operation_id_.bill_of_operations'
import { Route as DrawingsViewIdRouteImport } from './routes/drawings/view/$id'
import { Route as AdminPartnersPartnerIdRouteImport } from './routes/admin/partners/$partnerId'
import { Route as AdminFeatureFlagsFlagKeyRouteImport } from './routes/admin/feature-flags/$flagKey'
import { Route as AdminContainersContainerIdRouteImport } from './routes/admin/containers/$containerId'
import { Route as Vision_test_plansTest_plan_idRunsRun_idRouteImport } from './routes/vision_test_plans/$test_plan_id_.runs.$run_id'
import { Route as QualityPacksWorkOrderIdJobCardIdOrderNumberRouteImport } from './routes/quality-packs/$workOrderId_.$jobCardId.$orderNumber'

const Vision_test_plansRouteRoute = Vision_test_plansRouteRouteImport.update({
  id: '/vision_test_plans',
  path: '/vision_test_plans',
  getParentRoute: () => rootRouteImport,
} as any)
const QualityPacksRouteRoute = QualityPacksRouteRouteImport.update({
  id: '/quality-packs',
  path: '/quality-packs',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsRouteRoute = ProjectsRouteRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductsRouteRoute = ProductsRouteRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => rootRouteImport,
} as any)
const OperationsRouteRoute = OperationsRouteRouteImport.update({
  id: '/operations',
  path: '/operations',
  getParentRoute: () => rootRouteImport,
} as any)
const ImportsRouteRoute = ImportsRouteRouteImport.update({
  id: '/imports',
  path: '/imports',
  getParentRoute: () => rootRouteImport,
} as any)
const FactoriesRouteRoute = FactoriesRouteRouteImport.update({
  id: '/factories',
  path: '/factories',
  getParentRoute: () => rootRouteImport,
} as any)
const Cause_categoriesRouteRoute = Cause_categoriesRouteRouteImport.update({
  id: '/cause_categories',
  path: '/cause_categories',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRouteRoute = AdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const Vision_test_plansIndexRoute = Vision_test_plansIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => Vision_test_plansRouteRoute,
} as any)
const QualityPacksIndexRoute = QualityPacksIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => QualityPacksRouteRoute,
} as any)
const ProjectsIndexRoute = ProjectsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProjectsRouteRoute,
} as any)
const ProductsIndexRoute = ProductsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProductsRouteRoute,
} as any)
const ProductionPlannerIndexRoute = ProductionPlannerIndexRouteImport.update({
  id: '/production-planner/',
  path: '/production-planner/',
  getParentRoute: () => rootRouteImport,
} as any)
const OperationsIndexRoute = OperationsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OperationsRouteRoute,
} as any)
const InboxIndexRoute = InboxIndexRouteImport.update({
  id: '/inbox/',
  path: '/inbox/',
  getParentRoute: () => rootRouteImport,
} as any)
const ImportsIndexRoute = ImportsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ImportsRouteRoute,
} as any)
const FactoriesIndexRoute = FactoriesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => FactoriesRouteRoute,
} as any)
const DebugIndexRoute = DebugIndexRouteImport.update({
  id: '/debug/',
  path: '/debug/',
  getParentRoute: () => rootRouteImport,
} as any)
const Change_controlIndexRoute = Change_controlIndexRouteImport.update({
  id: '/change_control/',
  path: '/change_control/',
  getParentRoute: () => rootRouteImport,
} as any)
const Cause_categoriesIndexRoute = Cause_categoriesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => Cause_categoriesRouteRoute,
} as any)
const Bill_of_operationsIndexRoute = Bill_of_operationsIndexRouteImport.update({
  id: '/bill_of_operations/',
  path: '/bill_of_operations/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuditIndexRoute = AuditIndexRouteImport.update({
  id: '/audit/',
  path: '/audit/',
  getParentRoute: () => rootRouteImport,
} as any)
const Vision_test_plansTest_plan_idRoute =
  Vision_test_plansTest_plan_idRouteImport.update({
    id: '/$test_plan_id',
    path: '/$test_plan_id',
    getParentRoute: () => Vision_test_plansRouteRoute,
  } as any)
const QualityPacksWorkOrderIdRoute = QualityPacksWorkOrderIdRouteImport.update({
  id: '/$workOrderId',
  path: '/$workOrderId',
  getParentRoute: () => QualityPacksRouteRoute,
} as any)
const ProjectsTimelineRoute = ProjectsTimelineRouteImport.update({
  id: '/timeline',
  path: '/timeline',
  getParentRoute: () => ProjectsRouteRoute,
} as any)
const ProjectsProjectIdRoute = ProjectsProjectIdRouteImport.update({
  id: '/$projectId',
  path: '/$projectId',
  getParentRoute: () => ProjectsRouteRoute,
} as any)
const ProductsNewRoute = ProductsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => ProductsRouteRoute,
} as any)
const ProductsProductIdRoute = ProductsProductIdRouteImport.update({
  id: '/$productId',
  path: '/$productId',
  getParentRoute: () => ProductsRouteRoute,
} as any)
const ProductionPlannerTimelineRoute =
  ProductionPlannerTimelineRouteImport.update({
    id: '/production-planner/timeline',
    path: '/production-planner/timeline',
    getParentRoute: () => rootRouteImport,
  } as any)
const OperationsNewRoute = OperationsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => OperationsRouteRoute,
} as any)
const OperationsOperation_idRoute = OperationsOperation_idRouteImport.update({
  id: '/$operation_id',
  path: '/$operation_id',
  getParentRoute: () => OperationsRouteRoute,
} as any)
const ImportsImportIdRoute = ImportsImportIdRouteImport.update({
  id: '/$importId',
  path: '/$importId',
  getParentRoute: () => ImportsRouteRoute,
} as any)
const Change_controlRun_idRoute = Change_controlRun_idRouteImport.update({
  id: '/change_control/$run_id',
  path: '/change_control/$run_id',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductsContainersRouteRoute = ProductsContainersRouteRouteImport.update({
  id: '/containers',
  path: '/containers',
  getParentRoute: () => ProductsRouteRoute,
} as any)
const AdminPartnersRouteRoute = AdminPartnersRouteRouteImport.update({
  id: '/partners',
  path: '/partners',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminFeatureFlagsRouteRoute = AdminFeatureFlagsRouteRouteImport.update({
  id: '/feature-flags',
  path: '/feature-flags',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminContainersRouteRoute = AdminContainersRouteRouteImport.update({
  id: '/containers',
  path: '/containers',
  getParentRoute: () => AdminRouteRoute,
} as any)
const ProductsContainersIndexRoute = ProductsContainersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProductsContainersRouteRoute,
} as any)
const ColumnsStructuredConfigurationIndexRoute =
  ColumnsStructuredConfigurationIndexRouteImport.update({
    id: '/columns/structured-configuration/',
    path: '/columns/structured-configuration/',
    getParentRoute: () => rootRouteImport,
  } as any)
const ColumnsCustomConfigurationIndexRoute =
  ColumnsCustomConfigurationIndexRouteImport.update({
    id: '/columns/custom-configuration/',
    path: '/columns/custom-configuration/',
    getParentRoute: () => rootRouteImport,
  } as any)
const Bill_of_operationsRulesIndexRoute =
  Bill_of_operationsRulesIndexRouteImport.update({
    id: '/bill_of_operations/rules/',
    path: '/bill_of_operations/rules/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminPartnersIndexRoute = AdminPartnersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminPartnersRouteRoute,
} as any)
const AdminFeatureFlagsIndexRoute = AdminFeatureFlagsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminFeatureFlagsRouteRoute,
} as any)
const AdminContainersIndexRoute = AdminContainersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminContainersRouteRoute,
} as any)
const ProjectsProjectIdTimelineRoute =
  ProjectsProjectIdTimelineRouteImport.update({
    id: '/$projectId_/timeline',
    path: '/$projectId/timeline',
    getParentRoute: () => ProjectsRouteRoute,
  } as any)
const ProjectsProjectIdReleaseRoute =
  ProjectsProjectIdReleaseRouteImport.update({
    id: '/$projectId_/release',
    path: '/$projectId/release',
    getParentRoute: () => ProjectsRouteRoute,
  } as any)
const ProjectsProjectIdRedraftRoute =
  ProjectsProjectIdRedraftRouteImport.update({
    id: '/$projectId_/redraft',
    path: '/$projectId/redraft',
    getParentRoute: () => ProjectsRouteRoute,
  } as any)
const ProjectsProjectIdGanttRoute = ProjectsProjectIdGanttRouteImport.update({
  id: '/$projectId_/gantt',
  path: '/$projectId/gantt',
  getParentRoute: () => ProjectsRouteRoute,
} as any)
const ProjectsProjectIdBill_of_operationsRoute =
  ProjectsProjectIdBill_of_operationsRouteImport.update({
    id: '/$projectId_/bill_of_operations',
    path: '/$projectId/bill_of_operations',
    getParentRoute: () => ProjectsRouteRoute,
  } as any)
const ProductsContainersContainerIdRoute =
  ProductsContainersContainerIdRouteImport.update({
    id: '/$containerId',
    path: '/$containerId',
    getParentRoute: () => ProductsContainersRouteRoute,
  } as any)
const OperationsOperation_idStationsRoute =
  OperationsOperation_idStationsRouteImport.update({
    id: '/$operation_id_/stations',
    path: '/$operation_id/stations',
    getParentRoute: () => OperationsRouteRoute,
  } as any)
const OperationsOperation_idChecksRoute =
  OperationsOperation_idChecksRouteImport.update({
    id: '/$operation_id_/checks',
    path: '/$operation_id/checks',
    getParentRoute: () => OperationsRouteRoute,
  } as any)
const OperationsOperation_idBill_of_operationsRoute =
  OperationsOperation_idBill_of_operationsRouteImport.update({
    id: '/$operation_id_/bill_of_operations',
    path: '/$operation_id/bill_of_operations',
    getParentRoute: () => OperationsRouteRoute,
  } as any)
const DrawingsViewIdRoute = DrawingsViewIdRouteImport.update({
  id: '/drawings/view/$id',
  path: '/drawings/view/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminPartnersPartnerIdRoute = AdminPartnersPartnerIdRouteImport.update({
  id: '/$partnerId',
  path: '/$partnerId',
  getParentRoute: () => AdminPartnersRouteRoute,
} as any)
const AdminFeatureFlagsFlagKeyRoute =
  AdminFeatureFlagsFlagKeyRouteImport.update({
    id: '/$flagKey',
    path: '/$flagKey',
    getParentRoute: () => AdminFeatureFlagsRouteRoute,
  } as any)
const AdminContainersContainerIdRoute =
  AdminContainersContainerIdRouteImport.update({
    id: '/$containerId',
    path: '/$containerId',
    getParentRoute: () => AdminContainersRouteRoute,
  } as any)
const Vision_test_plansTest_plan_idRunsRun_idRoute =
  Vision_test_plansTest_plan_idRunsRun_idRouteImport.update({
    id: '/$test_plan_id_/runs/$run_id',
    path: '/$test_plan_id/runs/$run_id',
    getParentRoute: () => Vision_test_plansRouteRoute,
  } as any)
const QualityPacksWorkOrderIdJobCardIdOrderNumberRoute =
  QualityPacksWorkOrderIdJobCardIdOrderNumberRouteImport.update({
    id: '/$workOrderId_/$jobCardId/$orderNumber',
    path: '/$workOrderId/$jobCardId/$orderNumber',
    getParentRoute: () => QualityPacksRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/cause_categories': typeof Cause_categoriesRouteRouteWithChildren
  '/factories': typeof FactoriesRouteRouteWithChildren
  '/imports': typeof ImportsRouteRouteWithChildren
  '/operations': typeof OperationsRouteRouteWithChildren
  '/products': typeof ProductsRouteRouteWithChildren
  '/projects': typeof ProjectsRouteRouteWithChildren
  '/quality-packs': typeof QualityPacksRouteRouteWithChildren
  '/vision_test_plans': typeof Vision_test_plansRouteRouteWithChildren
  '/admin/containers': typeof AdminContainersRouteRouteWithChildren
  '/admin/feature-flags': typeof AdminFeatureFlagsRouteRouteWithChildren
  '/admin/partners': typeof AdminPartnersRouteRouteWithChildren
  '/products/containers': typeof ProductsContainersRouteRouteWithChildren
  '/change_control/$run_id': typeof Change_controlRun_idRoute
  '/imports/$importId': typeof ImportsImportIdRoute
  '/operations/$operation_id': typeof OperationsOperation_idRoute
  '/operations/new': typeof OperationsNewRoute
  '/production-planner/timeline': typeof ProductionPlannerTimelineRoute
  '/products/$productId': typeof ProductsProductIdRoute
  '/products/new': typeof ProductsNewRoute
  '/projects/$projectId': typeof ProjectsProjectIdRoute
  '/projects/timeline': typeof ProjectsTimelineRoute
  '/quality-packs/$workOrderId': typeof QualityPacksWorkOrderIdRoute
  '/vision_test_plans/$test_plan_id': typeof Vision_test_plansTest_plan_idRoute
  '/audit/': typeof AuditIndexRoute
  '/bill_of_operations/': typeof Bill_of_operationsIndexRoute
  '/cause_categories/': typeof Cause_categoriesIndexRoute
  '/change_control/': typeof Change_controlIndexRoute
  '/debug/': typeof DebugIndexRoute
  '/factories/': typeof FactoriesIndexRoute
  '/imports/': typeof ImportsIndexRoute
  '/inbox/': typeof InboxIndexRoute
  '/operations/': typeof OperationsIndexRoute
  '/production-planner/': typeof ProductionPlannerIndexRoute
  '/products/': typeof ProductsIndexRoute
  '/projects/': typeof ProjectsIndexRoute
  '/quality-packs/': typeof QualityPacksIndexRoute
  '/vision_test_plans/': typeof Vision_test_plansIndexRoute
  '/admin/containers/$containerId': typeof AdminContainersContainerIdRoute
  '/admin/feature-flags/$flagKey': typeof AdminFeatureFlagsFlagKeyRoute
  '/admin/partners/$partnerId': typeof AdminPartnersPartnerIdRoute
  '/drawings/view/$id': typeof DrawingsViewIdRoute
  '/operations/$operation_id/bill_of_operations': typeof OperationsOperation_idBill_of_operationsRoute
  '/operations/$operation_id/checks': typeof OperationsOperation_idChecksRoute
  '/operations/$operation_id/stations': typeof OperationsOperation_idStationsRoute
  '/products/containers/$containerId': typeof ProductsContainersContainerIdRoute
  '/projects/$projectId/bill_of_operations': typeof ProjectsProjectIdBill_of_operationsRoute
  '/projects/$projectId/gantt': typeof ProjectsProjectIdGanttRoute
  '/projects/$projectId/redraft': typeof ProjectsProjectIdRedraftRoute
  '/projects/$projectId/release': typeof ProjectsProjectIdReleaseRoute
  '/projects/$projectId/timeline': typeof ProjectsProjectIdTimelineRoute
  '/admin/containers/': typeof AdminContainersIndexRoute
  '/admin/feature-flags/': typeof AdminFeatureFlagsIndexRoute
  '/admin/partners/': typeof AdminPartnersIndexRoute
  '/bill_of_operations/rules/': typeof Bill_of_operationsRulesIndexRoute
  '/columns/custom-configuration/': typeof ColumnsCustomConfigurationIndexRoute
  '/columns/structured-configuration/': typeof ColumnsStructuredConfigurationIndexRoute
  '/products/containers/': typeof ProductsContainersIndexRoute
  '/quality-packs/$workOrderId/$jobCardId/$orderNumber': typeof QualityPacksWorkOrderIdJobCardIdOrderNumberRoute
  '/vision_test_plans/$test_plan_id/runs/$run_id': typeof Vision_test_plansTest_plan_idRunsRun_idRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/change_control/$run_id': typeof Change_controlRun_idRoute
  '/imports/$importId': typeof ImportsImportIdRoute
  '/operations/$operation_id': typeof OperationsOperation_idRoute
  '/operations/new': typeof OperationsNewRoute
  '/production-planner/timeline': typeof ProductionPlannerTimelineRoute
  '/products/$productId': typeof ProductsProductIdRoute
  '/products/new': typeof ProductsNewRoute
  '/projects/$projectId': typeof ProjectsProjectIdRoute
  '/projects/timeline': typeof ProjectsTimelineRoute
  '/quality-packs/$workOrderId': typeof QualityPacksWorkOrderIdRoute
  '/vision_test_plans/$test_plan_id': typeof Vision_test_plansTest_plan_idRoute
  '/audit': typeof AuditIndexRoute
  '/bill_of_operations': typeof Bill_of_operationsIndexRoute
  '/cause_categories': typeof Cause_categoriesIndexRoute
  '/change_control': typeof Change_controlIndexRoute
  '/debug': typeof DebugIndexRoute
  '/factories': typeof FactoriesIndexRoute
  '/imports': typeof ImportsIndexRoute
  '/inbox': typeof InboxIndexRoute
  '/operations': typeof OperationsIndexRoute
  '/production-planner': typeof ProductionPlannerIndexRoute
  '/products': typeof ProductsIndexRoute
  '/projects': typeof ProjectsIndexRoute
  '/quality-packs': typeof QualityPacksIndexRoute
  '/vision_test_plans': typeof Vision_test_plansIndexRoute
  '/admin/containers/$containerId': typeof AdminContainersContainerIdRoute
  '/admin/feature-flags/$flagKey': typeof AdminFeatureFlagsFlagKeyRoute
  '/admin/partners/$partnerId': typeof AdminPartnersPartnerIdRoute
  '/drawings/view/$id': typeof DrawingsViewIdRoute
  '/operations/$operation_id/bill_of_operations': typeof OperationsOperation_idBill_of_operationsRoute
  '/operations/$operation_id/checks': typeof OperationsOperation_idChecksRoute
  '/operations/$operation_id/stations': typeof OperationsOperation_idStationsRoute
  '/products/containers/$containerId': typeof ProductsContainersContainerIdRoute
  '/projects/$projectId/bill_of_operations': typeof ProjectsProjectIdBill_of_operationsRoute
  '/projects/$projectId/gantt': typeof ProjectsProjectIdGanttRoute
  '/projects/$projectId/redraft': typeof ProjectsProjectIdRedraftRoute
  '/projects/$projectId/release': typeof ProjectsProjectIdReleaseRoute
  '/projects/$projectId/timeline': typeof ProjectsProjectIdTimelineRoute
  '/admin/containers': typeof AdminContainersIndexRoute
  '/admin/feature-flags': typeof AdminFeatureFlagsIndexRoute
  '/admin/partners': typeof AdminPartnersIndexRoute
  '/bill_of_operations/rules': typeof Bill_of_operationsRulesIndexRoute
  '/columns/custom-configuration': typeof ColumnsCustomConfigurationIndexRoute
  '/columns/structured-configuration': typeof ColumnsStructuredConfigurationIndexRoute
  '/products/containers': typeof ProductsContainersIndexRoute
  '/quality-packs/$workOrderId/$jobCardId/$orderNumber': typeof QualityPacksWorkOrderIdJobCardIdOrderNumberRoute
  '/vision_test_plans/$test_plan_id/runs/$run_id': typeof Vision_test_plansTest_plan_idRunsRun_idRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/cause_categories': typeof Cause_categoriesRouteRouteWithChildren
  '/factories': typeof FactoriesRouteRouteWithChildren
  '/imports': typeof ImportsRouteRouteWithChildren
  '/operations': typeof OperationsRouteRouteWithChildren
  '/products': typeof ProductsRouteRouteWithChildren
  '/projects': typeof ProjectsRouteRouteWithChildren
  '/quality-packs': typeof QualityPacksRouteRouteWithChildren
  '/vision_test_plans': typeof Vision_test_plansRouteRouteWithChildren
  '/admin/containers': typeof AdminContainersRouteRouteWithChildren
  '/admin/feature-flags': typeof AdminFeatureFlagsRouteRouteWithChildren
  '/admin/partners': typeof AdminPartnersRouteRouteWithChildren
  '/products/containers': typeof ProductsContainersRouteRouteWithChildren
  '/change_control/$run_id': typeof Change_controlRun_idRoute
  '/imports/$importId': typeof ImportsImportIdRoute
  '/operations/$operation_id': typeof OperationsOperation_idRoute
  '/operations/new': typeof OperationsNewRoute
  '/production-planner/timeline': typeof ProductionPlannerTimelineRoute
  '/products/$productId': typeof ProductsProductIdRoute
  '/products/new': typeof ProductsNewRoute
  '/projects/$projectId': typeof ProjectsProjectIdRoute
  '/projects/timeline': typeof ProjectsTimelineRoute
  '/quality-packs/$workOrderId': typeof QualityPacksWorkOrderIdRoute
  '/vision_test_plans/$test_plan_id': typeof Vision_test_plansTest_plan_idRoute
  '/audit/': typeof AuditIndexRoute
  '/bill_of_operations/': typeof Bill_of_operationsIndexRoute
  '/cause_categories/': typeof Cause_categoriesIndexRoute
  '/change_control/': typeof Change_controlIndexRoute
  '/debug/': typeof DebugIndexRoute
  '/factories/': typeof FactoriesIndexRoute
  '/imports/': typeof ImportsIndexRoute
  '/inbox/': typeof InboxIndexRoute
  '/operations/': typeof OperationsIndexRoute
  '/production-planner/': typeof ProductionPlannerIndexRoute
  '/products/': typeof ProductsIndexRoute
  '/projects/': typeof ProjectsIndexRoute
  '/quality-packs/': typeof QualityPacksIndexRoute
  '/vision_test_plans/': typeof Vision_test_plansIndexRoute
  '/admin/containers/$containerId': typeof AdminContainersContainerIdRoute
  '/admin/feature-flags/$flagKey': typeof AdminFeatureFlagsFlagKeyRoute
  '/admin/partners/$partnerId': typeof AdminPartnersPartnerIdRoute
  '/drawings/view/$id': typeof DrawingsViewIdRoute
  '/operations/$operation_id_/bill_of_operations': typeof OperationsOperation_idBill_of_operationsRoute
  '/operations/$operation_id_/checks': typeof OperationsOperation_idChecksRoute
  '/operations/$operation_id_/stations': typeof OperationsOperation_idStationsRoute
  '/products/containers/$containerId': typeof ProductsContainersContainerIdRoute
  '/projects/$projectId_/bill_of_operations': typeof ProjectsProjectIdBill_of_operationsRoute
  '/projects/$projectId_/gantt': typeof ProjectsProjectIdGanttRoute
  '/projects/$projectId_/redraft': typeof ProjectsProjectIdRedraftRoute
  '/projects/$projectId_/release': typeof ProjectsProjectIdReleaseRoute
  '/projects/$projectId_/timeline': typeof ProjectsProjectIdTimelineRoute
  '/admin/containers/': typeof AdminContainersIndexRoute
  '/admin/feature-flags/': typeof AdminFeatureFlagsIndexRoute
  '/admin/partners/': typeof AdminPartnersIndexRoute
  '/bill_of_operations/rules/': typeof Bill_of_operationsRulesIndexRoute
  '/columns/custom-configuration/': typeof ColumnsCustomConfigurationIndexRoute
  '/columns/structured-configuration/': typeof ColumnsStructuredConfigurationIndexRoute
  '/products/containers/': typeof ProductsContainersIndexRoute
  '/quality-packs/$workOrderId_/$jobCardId/$orderNumber': typeof QualityPacksWorkOrderIdJobCardIdOrderNumberRoute
  '/vision_test_plans/$test_plan_id_/runs/$run_id': typeof Vision_test_plansTest_plan_idRunsRun_idRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/cause_categories'
    | '/factories'
    | '/imports'
    | '/operations'
    | '/products'
    | '/projects'
    | '/quality-packs'
    | '/vision_test_plans'
    | '/admin/containers'
    | '/admin/feature-flags'
    | '/admin/partners'
    | '/products/containers'
    | '/change_control/$run_id'
    | '/imports/$importId'
    | '/operations/$operation_id'
    | '/operations/new'
    | '/production-planner/timeline'
    | '/products/$productId'
    | '/products/new'
    | '/projects/$projectId'
    | '/projects/timeline'
    | '/quality-packs/$workOrderId'
    | '/vision_test_plans/$test_plan_id'
    | '/audit/'
    | '/bill_of_operations/'
    | '/cause_categories/'
    | '/change_control/'
    | '/debug/'
    | '/factories/'
    | '/imports/'
    | '/inbox/'
    | '/operations/'
    | '/production-planner/'
    | '/products/'
    | '/projects/'
    | '/quality-packs/'
    | '/vision_test_plans/'
    | '/admin/containers/$containerId'
    | '/admin/feature-flags/$flagKey'
    | '/admin/partners/$partnerId'
    | '/drawings/view/$id'
    | '/operations/$operation_id/bill_of_operations'
    | '/operations/$operation_id/checks'
    | '/operations/$operation_id/stations'
    | '/products/containers/$containerId'
    | '/projects/$projectId/bill_of_operations'
    | '/projects/$projectId/gantt'
    | '/projects/$projectId/redraft'
    | '/projects/$projectId/release'
    | '/projects/$projectId/timeline'
    | '/admin/containers/'
    | '/admin/feature-flags/'
    | '/admin/partners/'
    | '/bill_of_operations/rules/'
    | '/columns/custom-configuration/'
    | '/columns/structured-configuration/'
    | '/products/containers/'
    | '/quality-packs/$workOrderId/$jobCardId/$orderNumber'
    | '/vision_test_plans/$test_plan_id/runs/$run_id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/change_control/$run_id'
    | '/imports/$importId'
    | '/operations/$operation_id'
    | '/operations/new'
    | '/production-planner/timeline'
    | '/products/$productId'
    | '/products/new'
    | '/projects/$projectId'
    | '/projects/timeline'
    | '/quality-packs/$workOrderId'
    | '/vision_test_plans/$test_plan_id'
    | '/audit'
    | '/bill_of_operations'
    | '/cause_categories'
    | '/change_control'
    | '/debug'
    | '/factories'
    | '/imports'
    | '/inbox'
    | '/operations'
    | '/production-planner'
    | '/products'
    | '/projects'
    | '/quality-packs'
    | '/vision_test_plans'
    | '/admin/containers/$containerId'
    | '/admin/feature-flags/$flagKey'
    | '/admin/partners/$partnerId'
    | '/drawings/view/$id'
    | '/operations/$operation_id/bill_of_operations'
    | '/operations/$operation_id/checks'
    | '/operations/$operation_id/stations'
    | '/products/containers/$containerId'
    | '/projects/$projectId/bill_of_operations'
    | '/projects/$projectId/gantt'
    | '/projects/$projectId/redraft'
    | '/projects/$projectId/release'
    | '/projects/$projectId/timeline'
    | '/admin/containers'
    | '/admin/feature-flags'
    | '/admin/partners'
    | '/bill_of_operations/rules'
    | '/columns/custom-configuration'
    | '/columns/structured-configuration'
    | '/products/containers'
    | '/quality-packs/$workOrderId/$jobCardId/$orderNumber'
    | '/vision_test_plans/$test_plan_id/runs/$run_id'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/cause_categories'
    | '/factories'
    | '/imports'
    | '/operations'
    | '/products'
    | '/projects'
    | '/quality-packs'
    | '/vision_test_plans'
    | '/admin/containers'
    | '/admin/feature-flags'
    | '/admin/partners'
    | '/products/containers'
    | '/change_control/$run_id'
    | '/imports/$importId'
    | '/operations/$operation_id'
    | '/operations/new'
    | '/production-planner/timeline'
    | '/products/$productId'
    | '/products/new'
    | '/projects/$projectId'
    | '/projects/timeline'
    | '/quality-packs/$workOrderId'
    | '/vision_test_plans/$test_plan_id'
    | '/audit/'
    | '/bill_of_operations/'
    | '/cause_categories/'
    | '/change_control/'
    | '/debug/'
    | '/factories/'
    | '/imports/'
    | '/inbox/'
    | '/operations/'
    | '/production-planner/'
    | '/products/'
    | '/projects/'
    | '/quality-packs/'
    | '/vision_test_plans/'
    | '/admin/containers/$containerId'
    | '/admin/feature-flags/$flagKey'
    | '/admin/partners/$partnerId'
    | '/drawings/view/$id'
    | '/operations/$operation_id_/bill_of_operations'
    | '/operations/$operation_id_/checks'
    | '/operations/$operation_id_/stations'
    | '/products/containers/$containerId'
    | '/projects/$projectId_/bill_of_operations'
    | '/projects/$projectId_/gantt'
    | '/projects/$projectId_/redraft'
    | '/projects/$projectId_/release'
    | '/projects/$projectId_/timeline'
    | '/admin/containers/'
    | '/admin/feature-flags/'
    | '/admin/partners/'
    | '/bill_of_operations/rules/'
    | '/columns/custom-configuration/'
    | '/columns/structured-configuration/'
    | '/products/containers/'
    | '/quality-packs/$workOrderId_/$jobCardId/$orderNumber'
    | '/vision_test_plans/$test_plan_id_/runs/$run_id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRouteRoute: typeof AdminRouteRouteWithChildren
  Cause_categoriesRouteRoute: typeof Cause_categoriesRouteRouteWithChildren
  FactoriesRouteRoute: typeof FactoriesRouteRouteWithChildren
  ImportsRouteRoute: typeof ImportsRouteRouteWithChildren
  OperationsRouteRoute: typeof OperationsRouteRouteWithChildren
  ProductsRouteRoute: typeof ProductsRouteRouteWithChildren
  ProjectsRouteRoute: typeof ProjectsRouteRouteWithChildren
  QualityPacksRouteRoute: typeof QualityPacksRouteRouteWithChildren
  Vision_test_plansRouteRoute: typeof Vision_test_plansRouteRouteWithChildren
  Change_controlRun_idRoute: typeof Change_controlRun_idRoute
  ProductionPlannerTimelineRoute: typeof ProductionPlannerTimelineRoute
  AuditIndexRoute: typeof AuditIndexRoute
  Bill_of_operationsIndexRoute: typeof Bill_of_operationsIndexRoute
  Change_controlIndexRoute: typeof Change_controlIndexRoute
  DebugIndexRoute: typeof DebugIndexRoute
  InboxIndexRoute: typeof InboxIndexRoute
  ProductionPlannerIndexRoute: typeof ProductionPlannerIndexRoute
  DrawingsViewIdRoute: typeof DrawingsViewIdRoute
  Bill_of_operationsRulesIndexRoute: typeof Bill_of_operationsRulesIndexRoute
  ColumnsCustomConfigurationIndexRoute: typeof ColumnsCustomConfigurationIndexRoute
  ColumnsStructuredConfigurationIndexRoute: typeof ColumnsStructuredConfigurationIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/vision_test_plans': {
      id: '/vision_test_plans'
      path: '/vision_test_plans'
      fullPath: '/vision_test_plans'
      preLoaderRoute: typeof Vision_test_plansRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/quality-packs': {
      id: '/quality-packs'
      path: '/quality-packs'
      fullPath: '/quality-packs'
      preLoaderRoute: typeof QualityPacksRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects': {
      id: '/projects'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof ProjectsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products': {
      id: '/products'
      path: '/products'
      fullPath: '/products'
      preLoaderRoute: typeof ProductsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/operations': {
      id: '/operations'
      path: '/operations'
      fullPath: '/operations'
      preLoaderRoute: typeof OperationsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/imports': {
      id: '/imports'
      path: '/imports'
      fullPath: '/imports'
      preLoaderRoute: typeof ImportsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/factories': {
      id: '/factories'
      path: '/factories'
      fullPath: '/factories'
      preLoaderRoute: typeof FactoriesRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cause_categories': {
      id: '/cause_categories'
      path: '/cause_categories'
      fullPath: '/cause_categories'
      preLoaderRoute: typeof Cause_categoriesRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vision_test_plans/': {
      id: '/vision_test_plans/'
      path: '/'
      fullPath: '/vision_test_plans/'
      preLoaderRoute: typeof Vision_test_plansIndexRouteImport
      parentRoute: typeof Vision_test_plansRouteRoute
    }
    '/quality-packs/': {
      id: '/quality-packs/'
      path: '/'
      fullPath: '/quality-packs/'
      preLoaderRoute: typeof QualityPacksIndexRouteImport
      parentRoute: typeof QualityPacksRouteRoute
    }
    '/projects/': {
      id: '/projects/'
      path: '/'
      fullPath: '/projects/'
      preLoaderRoute: typeof ProjectsIndexRouteImport
      parentRoute: typeof ProjectsRouteRoute
    }
    '/products/': {
      id: '/products/'
      path: '/'
      fullPath: '/products/'
      preLoaderRoute: typeof ProductsIndexRouteImport
      parentRoute: typeof ProductsRouteRoute
    }
    '/production-planner/': {
      id: '/production-planner/'
      path: '/production-planner'
      fullPath: '/production-planner/'
      preLoaderRoute: typeof ProductionPlannerIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/operations/': {
      id: '/operations/'
      path: '/'
      fullPath: '/operations/'
      preLoaderRoute: typeof OperationsIndexRouteImport
      parentRoute: typeof OperationsRouteRoute
    }
    '/inbox/': {
      id: '/inbox/'
      path: '/inbox'
      fullPath: '/inbox/'
      preLoaderRoute: typeof InboxIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/imports/': {
      id: '/imports/'
      path: '/'
      fullPath: '/imports/'
      preLoaderRoute: typeof ImportsIndexRouteImport
      parentRoute: typeof ImportsRouteRoute
    }
    '/factories/': {
      id: '/factories/'
      path: '/'
      fullPath: '/factories/'
      preLoaderRoute: typeof FactoriesIndexRouteImport
      parentRoute: typeof FactoriesRouteRoute
    }
    '/debug/': {
      id: '/debug/'
      path: '/debug'
      fullPath: '/debug/'
      preLoaderRoute: typeof DebugIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/change_control/': {
      id: '/change_control/'
      path: '/change_control'
      fullPath: '/change_control/'
      preLoaderRoute: typeof Change_controlIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cause_categories/': {
      id: '/cause_categories/'
      path: '/'
      fullPath: '/cause_categories/'
      preLoaderRoute: typeof Cause_categoriesIndexRouteImport
      parentRoute: typeof Cause_categoriesRouteRoute
    }
    '/bill_of_operations/': {
      id: '/bill_of_operations/'
      path: '/bill_of_operations'
      fullPath: '/bill_of_operations/'
      preLoaderRoute: typeof Bill_of_operationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audit/': {
      id: '/audit/'
      path: '/audit'
      fullPath: '/audit/'
      preLoaderRoute: typeof AuditIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vision_test_plans/$test_plan_id': {
      id: '/vision_test_plans/$test_plan_id'
      path: '/$test_plan_id'
      fullPath: '/vision_test_plans/$test_plan_id'
      preLoaderRoute: typeof Vision_test_plansTest_plan_idRouteImport
      parentRoute: typeof Vision_test_plansRouteRoute
    }
    '/quality-packs/$workOrderId': {
      id: '/quality-packs/$workOrderId'
      path: '/$workOrderId'
      fullPath: '/quality-packs/$workOrderId'
      preLoaderRoute: typeof QualityPacksWorkOrderIdRouteImport
      parentRoute: typeof QualityPacksRouteRoute
    }
    '/projects/timeline': {
      id: '/projects/timeline'
      path: '/timeline'
      fullPath: '/projects/timeline'
      preLoaderRoute: typeof ProjectsTimelineRouteImport
      parentRoute: typeof ProjectsRouteRoute
    }
    '/projects/$projectId': {
      id: '/projects/$projectId'
      path: '/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof ProjectsProjectIdRouteImport
      parentRoute: typeof ProjectsRouteRoute
    }
    '/products/new': {
      id: '/products/new'
      path: '/new'
      fullPath: '/products/new'
      preLoaderRoute: typeof ProductsNewRouteImport
      parentRoute: typeof ProductsRouteRoute
    }
    '/products/$productId': {
      id: '/products/$productId'
      path: '/$productId'
      fullPath: '/products/$productId'
      preLoaderRoute: typeof ProductsProductIdRouteImport
      parentRoute: typeof ProductsRouteRoute
    }
    '/production-planner/timeline': {
      id: '/production-planner/timeline'
      path: '/production-planner/timeline'
      fullPath: '/production-planner/timeline'
      preLoaderRoute: typeof ProductionPlannerTimelineRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/operations/new': {
      id: '/operations/new'
      path: '/new'
      fullPath: '/operations/new'
      preLoaderRoute: typeof OperationsNewRouteImport
      parentRoute: typeof OperationsRouteRoute
    }
    '/operations/$operation_id': {
      id: '/operations/$operation_id'
      path: '/$operation_id'
      fullPath: '/operations/$operation_id'
      preLoaderRoute: typeof OperationsOperation_idRouteImport
      parentRoute: typeof OperationsRouteRoute
    }
    '/imports/$importId': {
      id: '/imports/$importId'
      path: '/$importId'
      fullPath: '/imports/$importId'
      preLoaderRoute: typeof ImportsImportIdRouteImport
      parentRoute: typeof ImportsRouteRoute
    }
    '/change_control/$run_id': {
      id: '/change_control/$run_id'
      path: '/change_control/$run_id'
      fullPath: '/change_control/$run_id'
      preLoaderRoute: typeof Change_controlRun_idRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products/containers': {
      id: '/products/containers'
      path: '/containers'
      fullPath: '/products/containers'
      preLoaderRoute: typeof ProductsContainersRouteRouteImport
      parentRoute: typeof ProductsRouteRoute
    }
    '/admin/partners': {
      id: '/admin/partners'
      path: '/partners'
      fullPath: '/admin/partners'
      preLoaderRoute: typeof AdminPartnersRouteRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/feature-flags': {
      id: '/admin/feature-flags'
      path: '/feature-flags'
      fullPath: '/admin/feature-flags'
      preLoaderRoute: typeof AdminFeatureFlagsRouteRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/containers': {
      id: '/admin/containers'
      path: '/containers'
      fullPath: '/admin/containers'
      preLoaderRoute: typeof AdminContainersRouteRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/products/containers/': {
      id: '/products/containers/'
      path: '/'
      fullPath: '/products/containers/'
      preLoaderRoute: typeof ProductsContainersIndexRouteImport
      parentRoute: typeof ProductsContainersRouteRoute
    }
    '/columns/structured-configuration/': {
      id: '/columns/structured-configuration/'
      path: '/columns/structured-configuration'
      fullPath: '/columns/structured-configuration/'
      preLoaderRoute: typeof ColumnsStructuredConfigurationIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/columns/custom-configuration/': {
      id: '/columns/custom-configuration/'
      path: '/columns/custom-configuration'
      fullPath: '/columns/custom-configuration/'
      preLoaderRoute: typeof ColumnsCustomConfigurationIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bill_of_operations/rules/': {
      id: '/bill_of_operations/rules/'
      path: '/bill_of_operations/rules'
      fullPath: '/bill_of_operations/rules/'
      preLoaderRoute: typeof Bill_of_operationsRulesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/partners/': {
      id: '/admin/partners/'
      path: '/'
      fullPath: '/admin/partners/'
      preLoaderRoute: typeof AdminPartnersIndexRouteImport
      parentRoute: typeof AdminPartnersRouteRoute
    }
    '/admin/feature-flags/': {
      id: '/admin/feature-flags/'
      path: '/'
      fullPath: '/admin/feature-flags/'
      preLoaderRoute: typeof AdminFeatureFlagsIndexRouteImport
      parentRoute: typeof AdminFeatureFlagsRouteRoute
    }
    '/admin/containers/': {
      id: '/admin/containers/'
      path: '/'
      fullPath: '/admin/containers/'
      preLoaderRoute: typeof AdminContainersIndexRouteImport
      parentRoute: typeof AdminContainersRouteRoute
    }
    '/projects/$projectId_/timeline': {
      id: '/projects/$projectId_/timeline'
      path: '/$projectId/timeline'
      fullPath: '/projects/$projectId/timeline'
      preLoaderRoute: typeof ProjectsProjectIdTimelineRouteImport
      parentRoute: typeof ProjectsRouteRoute
    }
    '/projects/$projectId_/release': {
      id: '/projects/$projectId_/release'
      path: '/$projectId/release'
      fullPath: '/projects/$projectId/release'
      preLoaderRoute: typeof ProjectsProjectIdReleaseRouteImport
      parentRoute: typeof ProjectsRouteRoute
    }
    '/projects/$projectId_/redraft': {
      id: '/projects/$projectId_/redraft'
      path: '/$projectId/redraft'
      fullPath: '/projects/$projectId/redraft'
      preLoaderRoute: typeof ProjectsProjectIdRedraftRouteImport
      parentRoute: typeof ProjectsRouteRoute
    }
    '/projects/$projectId_/gantt': {
      id: '/projects/$projectId_/gantt'
      path: '/$projectId/gantt'
      fullPath: '/projects/$projectId/gantt'
      preLoaderRoute: typeof ProjectsProjectIdGanttRouteImport
      parentRoute: typeof ProjectsRouteRoute
    }
    '/projects/$projectId_/bill_of_operations': {
      id: '/projects/$projectId_/bill_of_operations'
      path: '/$projectId/bill_of_operations'
      fullPath: '/projects/$projectId/bill_of_operations'
      preLoaderRoute: typeof ProjectsProjectIdBill_of_operationsRouteImport
      parentRoute: typeof ProjectsRouteRoute
    }
    '/products/containers/$containerId': {
      id: '/products/containers/$containerId'
      path: '/$containerId'
      fullPath: '/products/containers/$containerId'
      preLoaderRoute: typeof ProductsContainersContainerIdRouteImport
      parentRoute: typeof ProductsContainersRouteRoute
    }
    '/operations/$operation_id_/stations': {
      id: '/operations/$operation_id_/stations'
      path: '/$operation_id/stations'
      fullPath: '/operations/$operation_id/stations'
      preLoaderRoute: typeof OperationsOperation_idStationsRouteImport
      parentRoute: typeof OperationsRouteRoute
    }
    '/operations/$operation_id_/checks': {
      id: '/operations/$operation_id_/checks'
      path: '/$operation_id/checks'
      fullPath: '/operations/$operation_id/checks'
      preLoaderRoute: typeof OperationsOperation_idChecksRouteImport
      parentRoute: typeof OperationsRouteRoute
    }
    '/operations/$operation_id_/bill_of_operations': {
      id: '/operations/$operation_id_/bill_of_operations'
      path: '/$operation_id/bill_of_operations'
      fullPath: '/operations/$operation_id/bill_of_operations'
      preLoaderRoute: typeof OperationsOperation_idBill_of_operationsRouteImport
      parentRoute: typeof OperationsRouteRoute
    }
    '/drawings/view/$id': {
      id: '/drawings/view/$id'
      path: '/drawings/view/$id'
      fullPath: '/drawings/view/$id'
      preLoaderRoute: typeof DrawingsViewIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/partners/$partnerId': {
      id: '/admin/partners/$partnerId'
      path: '/$partnerId'
      fullPath: '/admin/partners/$partnerId'
      preLoaderRoute: typeof AdminPartnersPartnerIdRouteImport
      parentRoute: typeof AdminPartnersRouteRoute
    }
    '/admin/feature-flags/$flagKey': {
      id: '/admin/feature-flags/$flagKey'
      path: '/$flagKey'
      fullPath: '/admin/feature-flags/$flagKey'
      preLoaderRoute: typeof AdminFeatureFlagsFlagKeyRouteImport
      parentRoute: typeof AdminFeatureFlagsRouteRoute
    }
    '/admin/containers/$containerId': {
      id: '/admin/containers/$containerId'
      path: '/$containerId'
      fullPath: '/admin/containers/$containerId'
      preLoaderRoute: typeof AdminContainersContainerIdRouteImport
      parentRoute: typeof AdminContainersRouteRoute
    }
    '/vision_test_plans/$test_plan_id_/runs/$run_id': {
      id: '/vision_test_plans/$test_plan_id_/runs/$run_id'
      path: '/$test_plan_id/runs/$run_id'
      fullPath: '/vision_test_plans/$test_plan_id/runs/$run_id'
      preLoaderRoute: typeof Vision_test_plansTest_plan_idRunsRun_idRouteImport
      parentRoute: typeof Vision_test_plansRouteRoute
    }
    '/quality-packs/$workOrderId_/$jobCardId/$orderNumber': {
      id: '/quality-packs/$workOrderId_/$jobCardId/$orderNumber'
      path: '/$workOrderId/$jobCardId/$orderNumber'
      fullPath: '/quality-packs/$workOrderId/$jobCardId/$orderNumber'
      preLoaderRoute: typeof QualityPacksWorkOrderIdJobCardIdOrderNumberRouteImport
      parentRoute: typeof QualityPacksRouteRoute
    }
  }
}

interface AdminContainersRouteRouteChildren {
  AdminContainersContainerIdRoute: typeof AdminContainersContainerIdRoute
  AdminContainersIndexRoute: typeof AdminContainersIndexRoute
}

const AdminContainersRouteRouteChildren: AdminContainersRouteRouteChildren = {
  AdminContainersContainerIdRoute: AdminContainersContainerIdRoute,
  AdminContainersIndexRoute: AdminContainersIndexRoute,
}

const AdminContainersRouteRouteWithChildren =
  AdminContainersRouteRoute._addFileChildren(AdminContainersRouteRouteChildren)

interface AdminFeatureFlagsRouteRouteChildren {
  AdminFeatureFlagsFlagKeyRoute: typeof AdminFeatureFlagsFlagKeyRoute
  AdminFeatureFlagsIndexRoute: typeof AdminFeatureFlagsIndexRoute
}

const AdminFeatureFlagsRouteRouteChildren: AdminFeatureFlagsRouteRouteChildren =
  {
    AdminFeatureFlagsFlagKeyRoute: AdminFeatureFlagsFlagKeyRoute,
    AdminFeatureFlagsIndexRoute: AdminFeatureFlagsIndexRoute,
  }

const AdminFeatureFlagsRouteRouteWithChildren =
  AdminFeatureFlagsRouteRoute._addFileChildren(
    AdminFeatureFlagsRouteRouteChildren,
  )

interface AdminPartnersRouteRouteChildren {
  AdminPartnersPartnerIdRoute: typeof AdminPartnersPartnerIdRoute
  AdminPartnersIndexRoute: typeof AdminPartnersIndexRoute
}

const AdminPartnersRouteRouteChildren: AdminPartnersRouteRouteChildren = {
  AdminPartnersPartnerIdRoute: AdminPartnersPartnerIdRoute,
  AdminPartnersIndexRoute: AdminPartnersIndexRoute,
}

const AdminPartnersRouteRouteWithChildren =
  AdminPartnersRouteRoute._addFileChildren(AdminPartnersRouteRouteChildren)

interface AdminRouteRouteChildren {
  AdminContainersRouteRoute: typeof AdminContainersRouteRouteWithChildren
  AdminFeatureFlagsRouteRoute: typeof AdminFeatureFlagsRouteRouteWithChildren
  AdminPartnersRouteRoute: typeof AdminPartnersRouteRouteWithChildren
}

const AdminRouteRouteChildren: AdminRouteRouteChildren = {
  AdminContainersRouteRoute: AdminContainersRouteRouteWithChildren,
  AdminFeatureFlagsRouteRoute: AdminFeatureFlagsRouteRouteWithChildren,
  AdminPartnersRouteRoute: AdminPartnersRouteRouteWithChildren,
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(
  AdminRouteRouteChildren,
)

interface Cause_categoriesRouteRouteChildren {
  Cause_categoriesIndexRoute: typeof Cause_categoriesIndexRoute
}

const Cause_categoriesRouteRouteChildren: Cause_categoriesRouteRouteChildren = {
  Cause_categoriesIndexRoute: Cause_categoriesIndexRoute,
}

const Cause_categoriesRouteRouteWithChildren =
  Cause_categoriesRouteRoute._addFileChildren(
    Cause_categoriesRouteRouteChildren,
  )

interface FactoriesRouteRouteChildren {
  FactoriesIndexRoute: typeof FactoriesIndexRoute
}

const FactoriesRouteRouteChildren: FactoriesRouteRouteChildren = {
  FactoriesIndexRoute: FactoriesIndexRoute,
}

const FactoriesRouteRouteWithChildren = FactoriesRouteRoute._addFileChildren(
  FactoriesRouteRouteChildren,
)

interface ImportsRouteRouteChildren {
  ImportsImportIdRoute: typeof ImportsImportIdRoute
  ImportsIndexRoute: typeof ImportsIndexRoute
}

const ImportsRouteRouteChildren: ImportsRouteRouteChildren = {
  ImportsImportIdRoute: ImportsImportIdRoute,
  ImportsIndexRoute: ImportsIndexRoute,
}

const ImportsRouteRouteWithChildren = ImportsRouteRoute._addFileChildren(
  ImportsRouteRouteChildren,
)

interface OperationsRouteRouteChildren {
  OperationsOperation_idRoute: typeof OperationsOperation_idRoute
  OperationsNewRoute: typeof OperationsNewRoute
  OperationsIndexRoute: typeof OperationsIndexRoute
  OperationsOperation_idBill_of_operationsRoute: typeof OperationsOperation_idBill_of_operationsRoute
  OperationsOperation_idChecksRoute: typeof OperationsOperation_idChecksRoute
  OperationsOperation_idStationsRoute: typeof OperationsOperation_idStationsRoute
}

const OperationsRouteRouteChildren: OperationsRouteRouteChildren = {
  OperationsOperation_idRoute: OperationsOperation_idRoute,
  OperationsNewRoute: OperationsNewRoute,
  OperationsIndexRoute: OperationsIndexRoute,
  OperationsOperation_idBill_of_operationsRoute:
    OperationsOperation_idBill_of_operationsRoute,
  OperationsOperation_idChecksRoute: OperationsOperation_idChecksRoute,
  OperationsOperation_idStationsRoute: OperationsOperation_idStationsRoute,
}

const OperationsRouteRouteWithChildren = OperationsRouteRoute._addFileChildren(
  OperationsRouteRouteChildren,
)

interface ProductsContainersRouteRouteChildren {
  ProductsContainersContainerIdRoute: typeof ProductsContainersContainerIdRoute
  ProductsContainersIndexRoute: typeof ProductsContainersIndexRoute
}

const ProductsContainersRouteRouteChildren: ProductsContainersRouteRouteChildren =
  {
    ProductsContainersContainerIdRoute: ProductsContainersContainerIdRoute,
    ProductsContainersIndexRoute: ProductsContainersIndexRoute,
  }

const ProductsContainersRouteRouteWithChildren =
  ProductsContainersRouteRoute._addFileChildren(
    ProductsContainersRouteRouteChildren,
  )

interface ProductsRouteRouteChildren {
  ProductsContainersRouteRoute: typeof ProductsContainersRouteRouteWithChildren
  ProductsProductIdRoute: typeof ProductsProductIdRoute
  ProductsNewRoute: typeof ProductsNewRoute
  ProductsIndexRoute: typeof ProductsIndexRoute
}

const ProductsRouteRouteChildren: ProductsRouteRouteChildren = {
  ProductsContainersRouteRoute: ProductsContainersRouteRouteWithChildren,
  ProductsProductIdRoute: ProductsProductIdRoute,
  ProductsNewRoute: ProductsNewRoute,
  ProductsIndexRoute: ProductsIndexRoute,
}

const ProductsRouteRouteWithChildren = ProductsRouteRoute._addFileChildren(
  ProductsRouteRouteChildren,
)

interface ProjectsRouteRouteChildren {
  ProjectsProjectIdRoute: typeof ProjectsProjectIdRoute
  ProjectsTimelineRoute: typeof ProjectsTimelineRoute
  ProjectsIndexRoute: typeof ProjectsIndexRoute
  ProjectsProjectIdBill_of_operationsRoute: typeof ProjectsProjectIdBill_of_operationsRoute
  ProjectsProjectIdGanttRoute: typeof ProjectsProjectIdGanttRoute
  ProjectsProjectIdRedraftRoute: typeof ProjectsProjectIdRedraftRoute
  ProjectsProjectIdReleaseRoute: typeof ProjectsProjectIdReleaseRoute
  ProjectsProjectIdTimelineRoute: typeof ProjectsProjectIdTimelineRoute
}

const ProjectsRouteRouteChildren: ProjectsRouteRouteChildren = {
  ProjectsProjectIdRoute: ProjectsProjectIdRoute,
  ProjectsTimelineRoute: ProjectsTimelineRoute,
  ProjectsIndexRoute: ProjectsIndexRoute,
  ProjectsProjectIdBill_of_operationsRoute:
    ProjectsProjectIdBill_of_operationsRoute,
  ProjectsProjectIdGanttRoute: ProjectsProjectIdGanttRoute,
  ProjectsProjectIdRedraftRoute: ProjectsProjectIdRedraftRoute,
  ProjectsProjectIdReleaseRoute: ProjectsProjectIdReleaseRoute,
  ProjectsProjectIdTimelineRoute: ProjectsProjectIdTimelineRoute,
}

const ProjectsRouteRouteWithChildren = ProjectsRouteRoute._addFileChildren(
  ProjectsRouteRouteChildren,
)

interface QualityPacksRouteRouteChildren {
  QualityPacksWorkOrderIdRoute: typeof QualityPacksWorkOrderIdRoute
  QualityPacksIndexRoute: typeof QualityPacksIndexRoute
  QualityPacksWorkOrderIdJobCardIdOrderNumberRoute: typeof QualityPacksWorkOrderIdJobCardIdOrderNumberRoute
}

const QualityPacksRouteRouteChildren: QualityPacksRouteRouteChildren = {
  QualityPacksWorkOrderIdRoute: QualityPacksWorkOrderIdRoute,
  QualityPacksIndexRoute: QualityPacksIndexRoute,
  QualityPacksWorkOrderIdJobCardIdOrderNumberRoute:
    QualityPacksWorkOrderIdJobCardIdOrderNumberRoute,
}

const QualityPacksRouteRouteWithChildren =
  QualityPacksRouteRoute._addFileChildren(QualityPacksRouteRouteChildren)

interface Vision_test_plansRouteRouteChildren {
  Vision_test_plansTest_plan_idRoute: typeof Vision_test_plansTest_plan_idRoute
  Vision_test_plansIndexRoute: typeof Vision_test_plansIndexRoute
  Vision_test_plansTest_plan_idRunsRun_idRoute: typeof Vision_test_plansTest_plan_idRunsRun_idRoute
}

const Vision_test_plansRouteRouteChildren: Vision_test_plansRouteRouteChildren =
  {
    Vision_test_plansTest_plan_idRoute: Vision_test_plansTest_plan_idRoute,
    Vision_test_plansIndexRoute: Vision_test_plansIndexRoute,
    Vision_test_plansTest_plan_idRunsRun_idRoute:
      Vision_test_plansTest_plan_idRunsRun_idRoute,
  }

const Vision_test_plansRouteRouteWithChildren =
  Vision_test_plansRouteRoute._addFileChildren(
    Vision_test_plansRouteRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRouteRoute: AdminRouteRouteWithChildren,
  Cause_categoriesRouteRoute: Cause_categoriesRouteRouteWithChildren,
  FactoriesRouteRoute: FactoriesRouteRouteWithChildren,
  ImportsRouteRoute: ImportsRouteRouteWithChildren,
  OperationsRouteRoute: OperationsRouteRouteWithChildren,
  ProductsRouteRoute: ProductsRouteRouteWithChildren,
  ProjectsRouteRoute: ProjectsRouteRouteWithChildren,
  QualityPacksRouteRoute: QualityPacksRouteRouteWithChildren,
  Vision_test_plansRouteRoute: Vision_test_plansRouteRouteWithChildren,
  Change_controlRun_idRoute: Change_controlRun_idRoute,
  ProductionPlannerTimelineRoute: ProductionPlannerTimelineRoute,
  AuditIndexRoute: AuditIndexRoute,
  Bill_of_operationsIndexRoute: Bill_of_operationsIndexRoute,
  Change_controlIndexRoute: Change_controlIndexRoute,
  DebugIndexRoute: DebugIndexRoute,
  InboxIndexRoute: InboxIndexRoute,
  ProductionPlannerIndexRoute: ProductionPlannerIndexRoute,
  DrawingsViewIdRoute: DrawingsViewIdRoute,
  Bill_of_operationsRulesIndexRoute: Bill_of_operationsRulesIndexRoute,
  ColumnsCustomConfigurationIndexRoute: ColumnsCustomConfigurationIndexRoute,
  ColumnsStructuredConfigurationIndexRoute:
    ColumnsStructuredConfigurationIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
